import { Box, Grid, Typography } from "@mui/material";
import Footer from "components/common/dialog/Footer";
import Header from "components/common/dialog/Header";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { checkoutSuccess } from "redux/slice/session/auth.slice";
import { assetsObj } from "services/images";

const SkylifeSuccess = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location.search);
  const checkout_id = queryParams.get("id");

  let uT = sessionStorage.getItem("pageType") || 1;
  let influencer_name = sessionStorage.getItem("influncer_name") || "";

  useEffect(() => {
    if (checkout_id) {
      dispatch(
        checkoutSuccess({
          checkout_id,
          user_platform_status: uT,
          influencer_name: influencer_name,
        }).unwrap().then((res)=>{
          sessionStorage.removeItem("pageType")
        })
      );
    }
  }, [checkout_id, dispatch, influencer_name, uT]);

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          overflow: "hidden",
          backgroundImage: `url(${assetsObj.gradientImg}) `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            height: "calc(100vh - 133px)",
            maxWidth: "auto",
          }}
        >
          <Box maxWidth="md">
            <Grid
              container
              item
              xs={12}
              sx={{
                margin: "auto",
                "@media (max-width: 599px)": {
                  marginBottom: 12,
                },
              }}
            >
              <Grid item xs={12}>
                <Typography
                  variant="h4"
                  sx={{
                    textAlign: "center",
                    color: "white",
                    fontWeight: 300,
                    marginBottom: 2,
                  }}
                >
                  Welcome to Affirmate!
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} className="m-auto">
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: "center",
                    color: "white",
                    fontWeight: 500,
                    marginBottom: 3,
                  }}
                >
                  Enjoy the 7-day free trial. We’ll email you a reminder when the trial ends with a payment link and a 35% off coupon code.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    color: "white",
                    fontSize: "16px",
                    marginBottom: 4,
                    fontWeight: 300,
                  }}
                >
                  Download the App
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    margin: "auto",
                    display: "flex",
                    gap: 1,
                    justifyContent: "center",
                    maxWidth: "35%",
                    "@media (max-width: 499px)": {
                      display: "flex",
                      flexDirection: "column",
                    },
                  }}
                >
                  <Grid item xs={12}>
                    <a
                      style={{
                        width: "100%",
                      }}
                      href="https://apps.apple.com/us/app/affirmate-90-sec-meditation/id6449148631"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={assetsObj.appStoreLogo} alt="App Store" />
                    </a>
                  </Grid>
                  <Grid item xs={12}>
                    <a
                      style={{
                        width: "100%",
                      }}
                      href="https://play.google.com/store/apps/details?id=com.affirmate.app"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={assetsObj.playStoreLogo} alt="Play Store" />
                    </a>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default SkylifeSuccess;
